// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntable, th, td {\r\n  border: 1px solid black;\r\n  border-collapse: collapse;\r\n  border-spacing: 5px;\n}\n.grecaptcha-badge{ \r\n    visibility: hidden;\n}\n@media print {\nhtml, body {\r\n        height: 99%;\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
